import RequestService from './request-service';

// Query the Pricing Engine for a price
export default class BetBuilderOddRequest extends RequestService {
    constructor() {
        super();
        this.endpoint = '/RequestBetPriceById';
        /**
         * Request method
         * @type {string}
         */
        this.method = 'post';

        this.postParams = {
            key: '',
            fixtureId: null, // The identifier of the fixture to request a price for
            culture: APP_SETTINGS.player.language, // Language to apply translations for. Can be blank for no translations
            sport: null, // Sport to request a price for
            bets: [], // A list of Global Identifier that represent each leg in the same-game-multi
            isLongId: true, // Indicates whether a long or short version of the Global Identifiers are being used
            returnAllTranslations: true, // returns translations for all cultures that are supported and have translations available
            requestType: 0, // Indicates the type of price requests, usually this should be standard, standard = 0, bot = 1, recanned = 2
            saveBetSlip: false, // If true, it tells BetBuilder that this is final price check and a bet has been successfully created
            returnBetResponse: true, // set to true to return the betResponse object which contains information about the BetSlip
        };
    }
}
